import React from "react";
import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../api";
import { AnalyticsChart } from "../components/AnalyticsChart";
import { agentKeys } from "../queryKeys";

interface AgentStats {
  message_count: number;
  conversation_count: number;
}

export function AnalyticsPage({ agentId }: { agentId: string }) {
  const { data: stats, isLoading: loading } = useQuery({
    queryKey: agentKeys.stats(agentId),
    queryFn: () => apiFetch<AgentStats>(`/api/agents/${agentId}/stats`),
  });

  return (
    <div className="analytics-page">
      <h2>Analytics</h2>
      <p className="page-subtitle">Overview of your agent's activity and engagement.</p>

      {loading ? (
        <div className="analytics-loading">
          <p>Loading statistics...</p>
        </div>
      ) : (
        <>
          <div className="analytics-stats">
            <div className="analytics-stat-card">
              <div className="analytics-stat-icon">
                <span className="material-symbols-outlined">chat</span>
              </div>
              <div className="analytics-stat-content">
                <h3>{stats?.conversation_count?.toLocaleString() ?? "0"}</h3>
                <p>Total Conversations</p>
              </div>
            </div>

            <div className="analytics-stat-card">
              <div className="analytics-stat-icon">
                <span className="material-symbols-outlined">message</span>
              </div>
              <div className="analytics-stat-content">
                <h3>{stats?.message_count?.toLocaleString() ?? "0"}</h3>
                <p>Total Messages</p>
              </div>
            </div>
          </div>

          <div className="analytics-chart-section">
            <AnalyticsChart agentId={agentId} />
          </div>
        </>
      )}
    </div>
  );
}
